<template>
  <div>
    <SummaryEvent v-if="summary" :event="event" />

    <DetailEvent v-else :event="event" />
  </div>
</template>

<script>
import CancelledEvent from '@/components/requests/leave/events/CancelledEvent'
import SummaryEvent from '@/components/requests/leave/timeline/SummaryEvent'
import DetailEvent from '@/components/requests/leave/timeline/DetailEvent'

export default {
  name: 'LeaveWasCancelled',

  components: { DetailEvent, SummaryEvent },

  props: {
    event: {
      type: CancelledEvent,
      required: true,
    },

    summary: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
